import React, {useState, useEffect} from 'react';
import axios from '@app/lib/axios';
import moment from 'moment';
import ReactTooltip from "react-tooltip";

import * as Constant from '@app/Constant.js';
import AppInfoModal from './AppInfoModal.js';
import AppVersionUpdateModal from './AppVersionUpdateModal.js';
import Spinner from '../../../components/Spinner';

const AppCurrentInfo = ({appId, tagList, update_date, platformList, dataCallback}) => {
    const [dataLoaded, setDataLoaded] = useState(false);
    const [appModalShow, setAppModalShow] = useState(false);
    const [appVersionModalShow, setVersionModalShow] = useState(false);
    const [appData, setAppData] = useState(null);

    const getAppData = (appId) => {
        axios({
          method: "get",
          url: Constant.API_DOMAIN+"/api/app_version/current/"+appId
        })
        .then(result => {
            const appData = result.data;
            if(appData.charger) {
                if(appData.charger.P) {
                    let planers = JSON.parse(JSON.stringify(appData.charger.P));
                    appData.charger.P_desc = planers.flatMap(p => p.desc);;
                }
                if(appData.charger.D) {
                    let developers = JSON.parse(JSON.stringify(appData.charger.D));
                    appData.charger.D_desc = developers.flatMap(d => d.desc);
                }
            }
            setAppData(appData);
            setDataLoaded(true);
          })
        .catch(error => {
            console.log(error);
            console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            setAppData(null);
            setDataLoaded(true);
        });
    }

    useEffect(() => {
        setDataLoaded(false);
        if(appId) {
            getAppData(appId);
        } else {
            setAppData(null);
            setDataLoaded(true);
        }
        
        return () => {};
    }, [appId, update_date]);

    const tagMap = {};
    if(tagList) {
        tagList.forEach((tag) => {
            tagMap[tag.id] = tag;
        });
    }

    const stopService = () => {
        if(window.confirm(`${appData.app.name} 서비스를 종료 하시겠습니까?`)) {
            axios({
              method: "put",
              url: Constant.API_DOMAIN+"/api/app_version/stopService/"+appId + "/0"
            })
            .then(result => {
                if(result.data.code != '200') {
                    alert(result.data.msg);
                } else {
                    alert('서비스 종료 되었습니다.');
                    dataCallback(null);
                }
              })
            .catch(error => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
        }
    }

    if(!dataLoaded) {
        return (
            <div className="text-center p-3">
                <span className="dashboard-spinner spinner-xl"/>
            </div>
        )
    } else if (dataLoaded && !appData) {
        return (
            <>
                <div className="text-center p-3 font-24">
                    <i className="fas fa-question"/>
                </div>
                <h6 className="text-center">
                    찾을 수 없습니다
                </h6>
            </>
        )
    }

    return (
        <>
            <div className="card-body pl-0 pr-0">
                
                {appData && appData.app && appData.app.thumb_url && 
                    (
                        <div className="user-avatar text-center d-block p-5">
                            <img className="" src={appData.app.thumb_url} alt="LOGO" style={{minWidth: '100px', maxWidth: '100%', height : "128px"}}/>
                        </div>
                    )
                }
                {!appData.app || !appData.app.thumb_url && 
                    (
                        <div className="text-center m-5" style={{fontSize: '95px'}}>
                            <span className="fas fa-file-image" />
                        </div>
                    )
                }

                <div className="text-center mb-2">
                    <h2 className="font-24 mb-2">
                        {appData.app.name}
                        <span
                            className="ml-1 font-16 text-primary far fa-edit"
                            onClick={()=>setAppModalShow(true)}
                            style={{cursor:'pointer'}}
                        />
                        <span
                            className={`ml-1 font-16 text-danger ml-1 fas fa-minus-circle`}
                            style={{cursor:'pointer'}}
                            onClick={() => {
                                stopService();
                            }}
                        />
                    </h2>
                </div>
                <div className="text-center mb-2">
                    {
                        appData.app.tags.map((tag) => {
                            return (
                                <>
                                    <span className="badge badge-light mr-1" data-tip data-for={`tooltip_${tag}`} effect='solid'>{tagMap[tag].name}</span>
                                    <ReactTooltip id={`tooltip_${tag}`} type='dark'>
                                        <span>{tagMap[tag].desc}</span>
                                    </ReactTooltip>
                                </>
                            )
                        })
                    }
                </div>
                <div className="text-center mb-2">
                    <p className="mb-0">사업 담당: 
                        {appData.charger.P && appData.charger.P_desc && (
                            <span className="text-dark font-medium ml-2">{appData.charger.P_desc.join(', ')}</span>
                            )
                        }
                    </p>
                    <p>개발 담당: 
                        {appData.charger.D && appData.charger.D_desc && (
                            <span className="text-dark font-medium ml-2">{appData.charger.D_desc.join(', ')}</span>
                            )
                        }
                    </p>
                </div>
                <div className="p-3 text-center">
                    <button className="btn btn-primary" onClick={()=>setVersionModalShow(true)}>업데이트 등록</button>
                </div>
            </div>
            <div className="card-body border-top p-0">
                <ul className="list-group list-group-flush">
                    {
                        appData.platformList.map((platform)=> {
                            return (
                                <li className="traffic-sales-content list-group-item font-16">
                                    <span className={`icon-circle p-1 pl-2 pr-2 text-${platform.platform_icon_color} bg-${platform.platform_icon_color}-light`}>
                                        <i className={`fab ${platform.platform_icon}`}></i>
                                    </span>
                                    <span>&nbsp;&nbsp;{platform.platform_name}</span>
                                    <span className="traffic-sales-amount">
                                        {` ver. ${platform.major}.${platform.minor}.${platform.revision}`}
                                        {platform.code ? ` (${platform.code})` : ''}
                                        <small className="ml-1 ml-2 text-muted">{platform.deploy_date}</small>
                                    </span>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        
            <AppInfoModal
                appId={appId}
                show={appModalShow}
                onHide={()=> {
                    setAppModalShow(false);
                }}
                tagList={tagList}
                platformList={platformList}
                dataCallback={appId => {
                    dataCallback(appId);
                }}
            />

            <AppVersionUpdateModal
                data={appData}
                platformList={platformList}
                show={appVersionModalShow}
                onHide={()=> {
                    setVersionModalShow(false);
                }}
                dataCallback={appId => {
                    dataCallback(appId);
                }}
            />
            
        </>
    );
}

export default AppCurrentInfo;